<template>
  <div>
    <b-card no-body>
      <b-card-body>
        <rc-overlay
          :show="loading"
          no-fade
          variant="white"
        >
          <b-card-title>
            {{ $t('navigation.settings.default-settings-tab.new-customer-defaults-title') }}
          </b-card-title>
          <b-card-sub-title class="mb-2">
            {{ $t('navigation.settings.default-settings-tab.new-customer-defaults-description') }}
          </b-card-sub-title>

          <b-row class="mt-1">
            <b-col>
              <label
                for="canMakeOnlineReservations"
                class="w-100 font-medium-1 cursor-pointer"
              >
                <b-form-checkbox
                  id="canMakeOnlineReservations"
                  v-model="config.newCustomerDefaults.canMakeOnlineReservations"
                  class="custom-control-success float-left"
                  name="check-button"
                  switch
                  @input="val => saveValue('newCustomerDefaults.canMakeOnlineReservations', val, true)"
                />
                {{ $t('customers.form.settings.can-make-online-reservations') }}
              </label>
            </b-col>
          </b-row>

          <b-row class="mt-1">
            <b-col cols="12">
              <h5>
                {{ $t('customers.form.billing-details.settlements') }}
              </h5>
            </b-col>

            <b-col cols="12">
              <b-form-group
                :label="$t('customers.form.billing-details.settlements-time')"
                label-for="settlements-time"
              >
                <v-select
                  v-model="config.newCustomerDefaults.settlementsTime"
                  input-id="settlements-time"
                  :clearable="false"
                  :options="settlementTimeOptions"
                  :searchable="false"
                  :reduce="option => option.id"
                  @input="val => saveValue('newCustomerDefaults.settlementsTime', val, true)"
                />
              </b-form-group>
            </b-col>

            <b-col
              cols="12"
              class="mb-50"
            >
              <b-form-group
                :label="$t('customers.form.billing-details.payment-deadline')"
                label-for="payment-deadline"
              >
                <b-input-group
                  :append="$tc('calendar.event.form.label.recurrence-interval-type.day', Number(config.newCustomerDefaults.paymentDeadline) || 7)"
                  class="input-group-merge"
                >
                  <b-form-input
                    id="payment-deadline"
                    v-model.number="config.newCustomerDefaults.paymentDeadline"
                    type="number"
                    step="1"
                    @input="val => saveValue('newCustomerDefaults.paymentDeadline', val)"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row class="mb-50 mt-1">
            <b-col cols="12">
              <h5>
                {{ $t('customers.form.cancellation-rules.title') }}
              </h5>
            </b-col>

            <b-col>
              <label
                for="canCancelReservations"
                class="w-100 font-medium-1 cursor-pointer"
              >
                <b-form-checkbox
                  id="canCancelReservations"
                  v-model="config.newCustomerDefaults.canCancelReservations"
                  class="custom-control-success float-left"
                  name="check-button"
                  switch
                  @input="val => { saveValue('newCustomerDefaults.canCancelReservations', val, true) }"
                />
                {{ $t('customers.form.cancellation-rules.label.can-cancel') }}
              </label>
            </b-col>
          </b-row>

          <b-row class="mb-50">
            <b-col
              cols="12"
              class="mb-50"
            >
              <b-form-group
                :label="$t('customers.form.cancellation-rules.label.free-cancellation-min-hours')"
                label-for="free-cancellation-min-hours"
              >
                <b-input-group
                  :append="$tc('shared.plural.hours-no-value', Number(config.newCustomerDefaults.freeCancellationMinHours) || 0)"
                  class="input-group-merge"
                >
                  <b-form-input
                    id="free-cancellation-min-hours"
                    v-model.number="config.newCustomerDefaults.freeCancellationMinHours"
                    type="number"
                    step="1"
                    @input="val => saveValue('newCustomerDefaults.freeCancellationMinHours', val)"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
        </rc-overlay>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import RcOverlay from '@/layouts/components/rc/RcOverlay'
import defaultSettingsSettingsTabSetup from '@/views/organization/settings/account/tabs/defaultSettingsSettingsTabSetup'

export default {
  components: {
    vSelect,
    RcOverlay,
  },
  setup: defaultSettingsSettingsTabSetup,
}
</script>

<style scoped>
</style>
